import React from 'react';
import Process from "../../../../components/process";
import GoogleMapReact from "google-map-react";
import IconForMap from "../../../trips/components/IconForMap";
import {Col} from "react-bootstrap";
import {useParams} from "react-router-dom";

const RightEditComponent = ({edit,citySyncCb,coordinates,link, defaultZoom}) => {
  if (!edit) return
  return (
    <Col lg={6}>
      <Process
        desc={"Достает координаты и русское название"}
        title={"Синхронизация c Places"}
        link={link}
        cb={(data)=>citySyncCb(data)}
      />
      {coordinates && <div style={{height: '370px', width: '100%'}}>
        <GoogleMapReact
          defaultCenter={{
            lat: 59.95,
            lng: 30.33
          }}
          defaultZoom={defaultZoom}
          center={coordinates}
        >
          <IconForMap lat={coordinates.lat} lng={coordinates.lng}/>
        </GoogleMapReact>
      </div>}
    </Col>
  );
};

export default RightEditComponent;
